/**
 * Карточка Web sites.
 */

import Typewriter from "../Typewriter/Typewriter";
import ServiceCard from "../ServiceCard/ServiceCard";
import IconWebsites from "../../assets/icons/IconWebsites";
import { SERVICE_WEBSITES } from "../../config/services";

function WebsitesCard() {
    const copy = SERVICE_WEBSITES;

    return (
        <ServiceCard variant="websites">
            <div className="group-9__icon group-9__icon_svg" aria-hidden="true">
                <IconWebsites />
            </div>
            <h3 className="group-9__title group-9__title_websites">
                <Typewriter text={copy.title} speed={copy.titleSpeed} delay={copy.titleDelay} />
            </h3>
            <p className="group-9__text">
                <Typewriter text={copy.text} speed={copy.textSpeed} delay={copy.textDelay} />
            </p>
        </ServiceCard>
    );
}

export default WebsitesCard;
// components/ServiceCards/WebsitesCard.js
